import React, { useEffect, useRef } from 'react';
import { Grid } from '@mui/material';
import Marquee from "react-fast-marquee";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Desktopthree.css";
import { useLanguage } from "../../context/LanguageContext";
import { getT } from "../../translations";

gsap.registerPlugin(ScrollTrigger);

function Desktopthree() {
  const sectionRef = useRef(null);
  const marqueeRef = useRef(null);
  const { lang } = useLanguage();
  const t = getT(lang);
  const text = t("marquee.text");
  const repeated = Array(10).fill(text).join("  \u00A0\u00A0\u00A0\u00A0 ");

  useEffect(() => {
    const section = sectionRef.current;
    const marquee = marqueeRef.current;
    if (!section || !marquee) return;
    gsap.set(marquee, { opacity: 0, y: 16 });
    gsap.to(marquee, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      ease: "power2.out",
      scrollTrigger: { trigger: section, start: "top 88%", toggleActions: "play none none none" },
    });
    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  return (
    <div ref={sectionRef} className="marquee-section">
      <Grid container>
        <Grid item md={12} xs={12} lg={12}>
          <div ref={marqueeRef}>
            <Marquee className="marquee-text" speed={80} gradient={false}>
              <p className="marquee-content">
                &nbsp;&nbsp;&nbsp;&nbsp; {repeated} &nbsp;&nbsp;&nbsp;&nbsp;
              </p>
            </Marquee>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default Desktopthree;
